
import DevicePanel from './DevicePanel.vue';

export default DevicePanel;
